import { UniformSlot } from '@uniformdev/canvas-react';

export interface UniformNavigationTabProps {
	label: string;
	// Uniform's `link` parameter returns the resolved path plus project-map metadata.
	href?: string | { path: string; type?: string; nodeId?: string; projectMapId?: string };
	urlSlug?: string;
	iconUrl?: string;
	iconSize?: 'x-small' | 'small' | 'medium' | 'large';
	disableIconPadding?: boolean;
}

export const resolveNavigationTabHref = (
	href?: UniformNavigationTabProps['href'],
	urlSlug?: string,
) => {
	const resolvedHref = typeof href === 'string' ? href : href?.path;
	return resolvedHref || urlSlug;
};

const UniformNavigationTab = () => <UniformSlot name="tabContents" />;

export default UniformNavigationTab;
